module.exports = __webpack_public_path__ + "static/media/Ut_junior_preta.be782021.png";